export default __webpack_public_path__ + "static/media/ic-share.8e2afbc9.svg";